import { render, staticRenderFns } from "./ModalAddProfissionaisEquipeMedica.vue?vue&type=template&id=0d56a4ee"
import script from "./ModalAddProfissionaisEquipeMedica.vue?vue&type=script&lang=ts"
export * from "./ModalAddProfissionaisEquipeMedica.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports